import {
  FETCH_COMMON_CONFIG_PENDING,
  FETCH_COMMON_CONFIG_REJECTED,
  FETCH_COMMON_CONFIG_FULFILLED,
} from "../../constants/commonConfig";

const initialState = {
  loading: false,
  error: false,
  success: false,
  data: null,
};

const commonConfig = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMMON_CONFIG_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        data: state.data ? state.data : null,
      };
    case FETCH_COMMON_CONFIG_REJECTED:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        data: null,
      };
    case FETCH_COMMON_CONFIG_FULFILLED:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        data: action.payload.data.Data,
      };
    default:
      return state;
  }
};

export default commonConfig;
